import React, { useEffect, useState } from 'react';

import { cn } from '../helpers/cn';

export type ListLoadingSpinnerProps = {
    className?: string;
    dotClass?: string;
};

export default function ListLoadingSpinner(props: ListLoadingSpinnerProps): React.JSX.Element | null {
    const { className, dotClass } = props;

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: hydration gate so animation only runs on the client
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <div className={cn(className || 'py-38', 'w-full justify-center flex')}>
            <div className="flex space-x-8 items-center">
                <div className="flex h-28 items-center animate-bounce">
                    <div className={cn(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')} />
                </div>
                <div className="flex h-28 items-center animate-bounce200">
                    <div className={cn(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')} />
                </div>
                <div className="flex h-28 items-center animate-bounce400">
                    <div className={cn(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')} />
                </div>
            </div>
        </div>
    );
}
